export const channels = Object.freeze({ Mobile: 'Mobile', Web: 'Web' });

export const defaultChannel = channels['Web'];
